// @flow
import {
    ADMIN_LIST,
    ADMIN_LIST_SUCCESS,
    ADMIN_LIST_FAILED,
    ADMIN_ADD,
    ADMIN_ADD_SUCCESS,
    ADMIN_ADD_FAILED,
    ADMIN_UPDATE,
    ADMIN_UPDATE_SUCCESS,
    ADMIN_UPDATE_FAILED,
    ADMIN_DELETE,
    ADMIN_DELETE_SUCCESS,
    ADMIN_DELETE_FAILED
} from './constants';

import { getLoggedInUser } from '../../helpers/authUtils';

const INIT_STATE = {
    user: getLoggedInUser(),
    loading: false,
};

type AdminAction = { type: string, payload: {} | string };
type State = { user?: {} | null, loading?: boolean, +value ?: boolean };

const Admin = (state: State = INIT_STATE, action: AdminAction) => {
    switch (action.type) {
        case ADMIN_LIST:
            return { ...state, listloading: true };
        case ADMIN_LIST_SUCCESS:
            return { ...state, Admin: action.payload, listloading: false, error: null };
        case ADMIN_LIST_FAILED:
            return { ...state, error: action.payload, loading: false };
        case ADMIN_ADD:
            return { ...state, loading: true };
        case ADMIN_ADD_SUCCESS:
            return { ...state, AdminAdd: action.payload, loading: false, error: null };
        case ADMIN_ADD_FAILED:
            return { ...state, error: action.payload, loading: false };
        case ADMIN_UPDATE:
            return { ...state, loading: true };
        case ADMIN_UPDATE_SUCCESS:
            return { ...state, AdminUpdate: action.payload, loading: false, error: null };
        case ADMIN_UPDATE_FAILED:
            return { ...state, error: action.payload, loading: false };
        case ADMIN_DELETE:
            return { ...state, loading: true };
        case ADMIN_DELETE_SUCCESS:
            return { ...state, AdminDelete: action.payload, loading: false, error: null };
        case ADMIN_DELETE_FAILED:
            return { ...state, error: action.payload, loading: false };
        default:
            return { ...state };
    }
};

export default Admin;
